import chain from '@/lib/axios-chain'
// 获取成本维护首页数据列表
export const getCostIndex = () => chain.create('/data/cost/index', 'get')
// 获取成本维护详情
export const getCostDetail = () => chain.create('/data/cost/detail', 'post')
// 添加成本维护
export const addCostRecord = () => chain.create('/data/cost/add', 'post')
// 成本维护发送
export const costRecordSend = () => chain.create('/data/cost/send', 'post')
// 成本维护取消弹窗
export const costRecordCancelDialog = () => chain.create('/data/cost/cancel', 'get')
// 获取维护内容团队
export const getMaintainTeam = () => chain.create('/user/team/getauthusersinfobypk', 'get')
// export const costRecordCancelDialog = () =>
//   chain.create('/data/cost/cancle', 'post')
// 获取统计内容数据信息
export const getCostContentDatas = () =>
  chain.create('/user/team/getauthusersinfobypk', 'get')
// 获取统计内容数据信息
export const saveCostMaintainDatas = () =>
  chain.create('/data/cost/add', 'post')
// 获取询盘数量
export const getInqueryNum = () => chain.create('/data/cost/getnum', 'post')
